import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { FiClock, FiStar, FiUsers, FiCheck, FiArrowRight, FiBriefcase, FiAward } from 'react-icons/fi';
import { getCourse } from '../utils/api';

export default function CourseDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('curriculum');

  useEffect(() => {
    getCourse(slug)
      .then(r => setCourse(r.data.course))
      .catch(() => navigate('/courses'))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="spinner-wrap" style={{ minHeight: '80vh' }}><div className="spinner" /></div>;
  if (!course) return null;

  const tabs = ['curriculum', 'tools', 'projects', 'internship'];

  return (
    <div style={{ paddingTop: 70 }}>
      <style>{`
        .cd-hero { background: linear-gradient(135deg, #0f172a, #1e3a5f); padding: 60px 0; }
        .cd-hero-inner { max-width: 1180px; margin: 0 auto; padding: 0 24px; display: grid; grid-template-columns: 1fr 360px; gap: 48px; align-items: start; }
        .cd-badge { display: inline-block; padding: 5px 14px; border-radius: 999px; font-size: 12px; font-weight: 700; font-family: var(--font-display); margin-bottom: 14px; }
        .cd-title { font-size: clamp(26px, 4vw, 38px); color: white; margin-bottom: 10px; }
        .cd-subtitle { color: #94a3b8; font-size: 16px; margin-bottom: 20px; line-height: 1.6; }
        .cd-meta { display: flex; gap: 20px; flex-wrap: wrap; margin-bottom: 20px; }
        .cd-meta-item { display: flex; align-items: center; gap: 6px; font-size: 14px; color: #cbd5e1; }
        .cd-highlights-list { list-style: none; display: flex; flex-direction: column; gap: 8px; }
        .cd-highlights-list li { display: flex; align-items: center; gap: 10px; color: #e2e8f0; font-size: 14px; }
        .cd-highlights-list li svg { color: #6ee7b7; flex-shrink: 0; }
        .cd-sticky { background: white; border-radius: var(--radius-xl); box-shadow: var(--shadow-xl); overflow: hidden; position: sticky; top: 84px; border: 1px solid var(--border); }
        .cd-sticky-header { background: linear-gradient(135deg, var(--primary), #2563eb); padding: 24px; }
        .cd-fee { color: white; }
        .cd-fee-total { font-size: 32px; font-weight: 800; font-family: var(--font-display); }
        .cd-fee-sub { font-size: 13px; color: rgba(255,255,255,0.7); margin-top: 2px; }
        .cd-sticky-body { padding: 20px; }
        .cd-sticky-features { list-style: none; margin: 16px 0; }
        .cd-sticky-features li { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--dark-3); padding: 6px 0; border-bottom: 1px solid var(--border); }
        .cd-sticky-features li svg { color: var(--success); }
        .cd-tabs { display: flex; gap: 0; border-bottom: 2px solid var(--border); margin-bottom: 32px; overflow-x: auto; }
        .cd-tab { padding: 14px 24px; font-size: 14px; font-weight: 600; font-family: var(--font-display); color: var(--mid); cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; white-space: nowrap; transition: var(--transition); background: none; border-top: none; border-left: none; border-right: none; }
        .cd-tab.active { color: var(--primary); border-bottom-color: var(--primary); }
        .cd-tab:hover { color: var(--primary); }
        .cd-week { margin-bottom: 20px; background: var(--bg); border-radius: var(--radius); padding: 16px 20px; border: 1px solid var(--border); }
        .cd-week-title { font-weight: 700; font-size: 14px; color: var(--primary); margin-bottom: 4px; }
        .cd-week-topic { font-weight: 600; font-size: 15px; color: var(--dark); margin-bottom: 8px; }
        .cd-week-subs { display: flex; flex-wrap: wrap; gap: 6px; }
        .cd-week-sub { background: var(--primary-light); color: var(--primary); padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: 500; }
        .tools-grid { display: flex; flex-wrap: wrap; gap: 10px; }
        .tool-tag { display: flex; align-items: center; gap: 6px; background: var(--bg); border: 1px solid var(--border); padding: 8px 16px; border-radius: var(--radius); font-size: 14px; font-weight: 500; color: var(--dark-3); }
        .project-card { background: var(--bg); border: 1px solid var(--border); border-radius: var(--radius-lg); padding: 20px; margin-bottom: 16px; }
        .project-card h4 { font-size: 16px; margin-bottom: 6px; }
        .project-card p { font-size: 14px; color: var(--mid); }
        .internship-box { background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border: 1px solid #6ee7b7; border-radius: var(--radius-lg); padding: 28px; margin-bottom: 24px; }
        .internship-box h3 { color: var(--success); margin-bottom: 6px; }
        .placement-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 20px; }
        .placement-item { background: white; border: 1px solid var(--border); border-radius: var(--radius); padding: 16px; display: flex; align-items: center; gap: 12px; }
        .placement-item svg { color: var(--success); }
        @media (max-width: 900px) {
          .cd-hero-inner { grid-template-columns: 1fr; }
          .cd-sticky { position: static; }
          .placement-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      {/* Hero */}
      <div className="cd-hero">
        <div className="cd-hero-inner">
          <div>
            <div className="cd-badge" style={{ background: 'rgba(26,86,219,0.25)', color: '#93c5fd' }}>{course.badge || course.category}</div>
            <h1 className="cd-title">{course.title}</h1>
            <p className="cd-subtitle">{course.description}</p>
            <div className="cd-meta">
              <span className="cd-meta-item"><FiClock size={14} /> {course.duration}</span>
              <span className="cd-meta-item"><FiStar size={14} fill="#f59e0b" color="#f59e0b" /> {course.rating} rating</span>
              <span className="cd-meta-item"><FiUsers size={14} /> {course.enrolledCount}+ enrolled</span>
            </div>
            <ul className="cd-highlights-list">
              {(course.highlights || []).map((h, i) => <li key={i}><FiCheck size={14} /> {h}</li>)}
            </ul>
          </div>
          <div>
            <div className="cd-sticky">
              <div className="cd-sticky-header">
                <div className="cd-fee">
                  <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginBottom: 4 }}>Total Program Fee</div>
                  <div className="cd-fee-total">₹{course.fee?.total?.toLocaleString()}</div>
                  <div className="cd-fee-sub">Start with ₹{course.fee?.registration?.toLocaleString()} registration fee</div>
                </div>
              </div>
              <div className="cd-sticky-body">
                <Link to={`/apply?course=${course._id}`} className="btn btn-accent" style={{ width: '100%', justifyContent: 'center', marginBottom: 10 }}>
                  Apply Now — Free <FiArrowRight size={15} />
                </Link>
                <Link to={`/payment/${course._id}?type=registration`} className="btn btn-outline" style={{ width: '100%', justifyContent: 'center' }}>
                  Pay ₹2,000 Registration
                </Link>
                <ul className="cd-sticky-features">
                  <li><FiCheck size={14} /> {course.duration} live training</li>
                  <li><FiCheck size={14} /> {course.internshipDetails?.duration} internship</li>
                  <li><FiCheck size={14} /> Resume & interview prep</li>
                  <li><FiCheck size={14} /> LinkedIn optimization</li>
                  <li><FiCheck size={14} /> Placement assistance</li>
                  <li><FiCheck size={14} /> Course + Internship certificate</li>
                </ul>
                <p style={{ fontSize: 12, color: 'var(--mid)', textAlign: 'center' }}>🔒 Secure payment via Razorpay</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <section className="section">
        <div className="container">
          <div className="cd-tabs">
            {tabs.map(t => (
              <button key={t} className={`cd-tab${activeTab === t ? ' active' : ''}`} onClick={() => setActiveTab(t)}>
                {t === 'curriculum' ? '📚 Curriculum' : t === 'tools' ? '🛠️ Tools' : t === 'projects' ? '🎯 Projects' : '💼 Internship & Placement'}
              </button>
            ))}
          </div>

          {activeTab === 'curriculum' && (
            <div>
              <h3 style={{ marginBottom: 24 }}>What You'll Learn</h3>
              {(course.curriculum || []).map((w, i) => (
                <div key={i} className="cd-week">
                  <div className="cd-week-title">{w.week}</div>
                  <div className="cd-week-topic">{w.topic}</div>
                  <div className="cd-week-subs">
                    {(w.subtopics || []).map((s, j) => <span key={j} className="cd-week-sub">{s}</span>)}
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'tools' && (
            <div>
              <h3 style={{ marginBottom: 24 }}>Tools & Technologies</h3>
              <div className="tools-grid">
                {(course.tools || []).map((t, i) => (
                  <div key={i} className="tool-tag">
                    <span style={{ fontSize: 16 }}>🔧</span> {t}
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'projects' && (
            <div>
              <h3 style={{ marginBottom: 24 }}>Real Projects You'll Build</h3>
              {(course.projects || []).map((p, i) => (
                <div key={i} className="project-card">
                  <h4>🎯 {p.title}</h4>
                  <p>{p.description}</p>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'internship' && (
            <div>
              <div className="internship-box">
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                  <FiBriefcase size={24} color="var(--success)" />
                  <h3 style={{ margin: 0 }}>Internship Program</h3>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 14 }}>
                  {[
                    ['Duration', course.internshipDetails?.duration],
                    ['Type', course.internshipDetails?.type],
                    ['Stipend', course.internshipDetails?.stipend],
                    ['Certificate', 'Verified & LinkedIn-ready'],
                  ].map(([k, v]) => (
                    <div key={k} style={{ background: 'white', padding: 14, borderRadius: 'var(--radius)', border: '1px solid #6ee7b7' }}>
                      <div style={{ fontSize: 11, color: 'var(--mid)', marginBottom: 3 }}>{k}</div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{v}</div>
                    </div>
                  ))}
                </div>
                <p style={{ fontSize: 14, color: 'var(--dark-3)' }}>{course.internshipDetails?.description}</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <FiAward size={24} color="var(--primary)" />
                <h3 style={{ margin: 0 }}>Placement Assistance</h3>
              </div>
              <div className="placement-grid">
                {[
                  { label: 'Resume Building & Review', icon: '📄' },
                  { label: 'Mock Interview Sessions', icon: '🎤' },
                  { label: 'LinkedIn Profile Optimization', icon: '💼' },
                  { label: 'Direct Job Referrals', icon: '🤝' },
                ].map((item, i) => (
                  <div key={i} className="placement-item">
                    <span style={{ fontSize: 24 }}>{item.icon}</span>
                    <span style={{ fontWeight: 500, fontSize: 14 }}>{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: 48, padding: '32px', background: 'linear-gradient(135deg, #f0f4ff, #fafbff)', borderRadius: 'var(--radius-xl)', border: '1px solid var(--border)' }}>
            <h3 style={{ marginBottom: 10 }}>Ready to enroll in {course.title}?</h3>
            <p style={{ color: 'var(--mid)', marginBottom: 24 }}>Apply today — it's free. Our team will review and reach out within 24 hours.</p>
            <Link to={`/apply?course=${course._id}`} className="btn btn-accent btn-lg">Apply Now — Free <FiArrowRight /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
